import React from "react";
import { string, shape, node } from "prop-types";
import ThemeConsumer from "../ThemeConsumer";

const Card = ({
  theme,
  icon,
  styleIcon,
  title,
  children,
  noCallToAction,
  badgeText = "Novo",
  showBadge = false,
  zIndex = 0,
}) => {
  return (
    <div className={theme.card} style={{ zIndex }}>
      <img src={icon} alt="" style={styleIcon} />
      <div className={theme.content}>
        <h3 className={theme.title}>
          {title}{" "}
          {showBadge && <span className={theme.badge}>{badgeText}</span>}
        </h3>
        {noCallToAction ? children : children.slice(0, -1)}
      </div>
      {noCallToAction ? null : children.slice(-1)}
    </div>
  );
};

Card.propTypes = {
  children: node,
  title: string.isRequired,
  icon: string.isRequired,

  theme: shape({
    card: string,
    title: string,
  }),
};

Card.defaultProps = {
  children: null,
  theme: {},
};

export default ThemeConsumer("UICard")(Card);



// WEBPACK FOOTER //
// ./src/shared/components/Card/index.js